import { Input } from '@chegg-ui/input'
import { colors, font, spacing } from '@chegg-ui/theme'
import { Typography } from '@chegg-ui/typography'
import styled from 'styled-components'
import { IconButton } from '@chegg-ui/button'

export const EditorHeaderContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${spacing.px12};
  position: relative;
`
export const ReviewButtonContainer = styled.div`
  display: flex;
  gap: ${spacing.px8};
`

export const StyledEditorTitle = styled(Typography)`
  color: rgba(0, 0, 0, 0.19);
`

export const TitleInput = styled(Input)`
  input {
    border: none;
    outline: none;
    font-size: ${font.size.px24};
    font-weight: ${font.weight.bold};
    color: ${colors.grey900};
    ::placeholder {
      color: ${colors.grey300};
    }
    :focus {
      box-shadow: none;
    }
    padding-left: ${spacing.px8};
  }
  margin-bottom: ${spacing.px8};
  border: none;
`

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`

export const CopyButton = styled(IconButton).attrs({
  size: 'medium',
  disableHoverAnimation: true,
  variant: 'simple',
})`
  background-color: ${({ disabled }) => (disabled ? colors.grey200 : 'none')};
`
